/** @format */
import { TFunction } from 'next-i18next';

import { Market } from '@toucan/client/global/market';

export const getSavedModelsUrl = ({
    activeMarket,
    t,
}: {
    activeMarket: Market;
    t: TFunction;
}) => {
    const accountSlug = t('account', { ns: 'urls' });

    const savedModelsSlug = t('saved-models', {
        ns: 'urls',
    });

    return `/${activeMarket.slug}/${accountSlug}/${savedModelsSlug}`;
};

export const getButtonLabel = ({
    isSaved,
    t,
}: {
    isSaved: boolean;
    t: TFunction;
}) => {
    return isSaved ? t('Remove from saved models') : t('Add to saved models');
};
